/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
/* eslint-disable no-console */
let slides = document.querySelectorAll('.wp-block-paisana-blocks-image-slides .swiper')

slides.forEach( slide => {
    let swiper = new Swiper( slide, {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        autoHeight: true,
        loop: true
    })
})

document.addEventListener('DOMContentLoaded', function() {
    const columnas = document.querySelectorAll('.wp-block-column:has(.is-style-diagonal-slide)');
    
    columnas.forEach(columna => {
        const img = columna.querySelector('.is-style-diagonal-slide img');
        if (!img) return;
        
        // Obtener altura de la imagen
        const alturaImg = img.offsetHeight;
        // Calcular 9% de la altura (no del ancho)
        const desplazamientoPx = alturaImg * 0.09;
        
        // Aplicar margen negativo
        columna.style.marginTop = `-${desplazamientoPx}px`;
        columna.style.marginBottom = `-4px`;
    });
});
/* eslint-enable no-console */
